import React, { useState } from 'react';

const Collapsible = ({children, name=''}) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleCollapsible = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="">
      {/* Button to toggle the collapsible */}
      <button
        onClick={toggleCollapsible}
        className="w-full bg-blue-500 text-white p-2 rounded-md focus:outline-none hover:bg-blue-600"
      >
        {isOpen ? 'Collapse ' + name : 'Expand ' + name}
      </button>

      {/* Collapsible content */}
      <div className={`transition-all duration-300 ${isOpen ? 'h-auto' : 'h-0 overflow-hidden'}`}>
        {children}
      </div>
    </div>
  );
};

export default Collapsible;